var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AifPmsGlobalUrl } from "@adapters/infrastructures/urlConfig/Markets/aifPmsURL";
import { AggregatedHoldingMapper, FolioDetailsMapper, HoldingQtyDetailsMapper, HoldingSummaryMapper, RecentClientSearchGetMapper, RecentClientSearchSaveMapper, TrxTypeListMapper, UccClientSearchMapper, UserPopupStatusMapper, UserPopupStatusSaveMapper, ValidateClientMapper, } from "@domains/features/Markets/AIF-PMS/mapper/GlobalMapper";
import { generateQueryString } from "@frameworks/pmsjourney/utils/generateQueryString";
import { encryptionEnable } from "@adapters/infrastructures/encryption";
var GlobalRepository = /** @class */ (function () {
    function GlobalRepository(http) {
        this.http = http;
    }
    GlobalRepository.prototype.trxTypeList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.trxTypeList);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, TrxTypeListMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.userPopupStatus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.userPopupStatus);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, UserPopupStatusMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.userPopupStatusSave = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.userPopupStatusSave);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, UserPopupStatusSaveMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.recentClientSearchGet = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.recentClientSearchGet);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, RecentClientSearchGetMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.recentClientSearchSave = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.recentClientSearchSave);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, RecentClientSearchSaveMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.validateClient = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.validateclient);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, ValidateClientMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.holdingSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.holdingsummary);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, HoldingSummaryMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.folioDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.foliodetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, FolioDetailsMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.holdingQtyDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.holdingqtydetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, HoldingQtyDetailsMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.aggregatedHolding = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.aggregatedholding);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                avoidAppID: true,
                                encryption: false,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, AggregatedHoldingMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.uccclientSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.uccclient + "?" + "".concat(generateQueryString(req)));
                        headers = new Headers();
                        headers.append("ApiKey", process.env.ELASTIC_SEARCH_CONFIG);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAppID: true,
                                headers: headers,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, UccClientSearchMapper(data)];
                }
            });
        });
    };
    GlobalRepository.prototype.ucccodeclientSearch = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(AifPmsGlobalUrl.uccCodeclient);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: req,
                                encryption: encryptionEnable,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return GlobalRepository;
}());
export default GlobalRepository;
